import React from 'react';
import { useParams } from 'react-router-dom';
import data from '../../data';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';


import "./project.scss";

export default function Project(props) {
  const { id } = useParams();
  //toutjour j'ai trouvé un prob pour find data by id this is the best solution//
    const webapp = data.webapps.find(webapp => String(webapp.id) === id);



    console.log(webapp);
  return (
    <div className="profileContent">
  
    <Card className="text-center" >
        <Card.Body>
        <Card.Header className='cardHeader'>
     
      <h1>{webapp.title}</h1></Card.Header>
          <Card.Text>
        
          <Alert variant="success">
      <Alert.Heading>  ce Site est dévelopé avec:<br/>
          <strong>
          {webapp.divlop}</strong></Alert.Heading>
      <p>
     
      {webapp.discription}
      </p>
    </Alert>
          </Card.Text>
        </Card.Body>
        <Card.Img variant="bottom" src={webapp.imgp} />
        <br/>
        <Card.Img variant="bottom" src={webapp.imgo} />
        <br/>
        <Card.Img variant="bottom" src={webapp.imgs} />
        <br/>
        <Card.Img variant="bottom" src={webapp.imgt} />
        <br/>
        <Card.Img variant="bottom" src={webapp.imgth} />
      </Card>
      
    </div>
  )
}
